"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var icons_1 = require("@ant-design/icons");
var dx_react_grid_material_ui_1 = require("@devexpress/dx-react-grid-material-ui");
var antd_1 = require("antd");
var categoriesList_1 = require("common/global/categoriesList");
var projectsList_1 = require("common/global/projectsList");
var unitsList_1 = require("common/global/unitsList");
var usersList_1 = require("common/global/usersList");
var moment_1 = __importDefault(require("moment"));
var exportWarehouseItemsTableToExcel_1 = require("portal/components/Grid/helpers/exportWarehouseItemsTableToExcel");
var hasProjectAndWarehousePermission_1 = require("portal/pages/Projects/hasProjectAndWarehousePermission");
var projectsForWarehouseRole_1 = require("portal/pages/Projects/projectsForWarehouseRole");
var defaultDevExtremeGridComponents_1 = __importDefault(require("portal/utils/defaultDevExtremeGridComponents"));
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var approveSendDonationItem_1 = __importDefault(require("../Dialogs/approveSendDonationItem"));
var reduxHooks_1 = require("portal/hooks/reduxHooks");
var warehouseSendDonationOperationsSlice_1 = require("src/features/warehouseSendDonationOperations/warehouseSendDonationOperationsSlice");
function WarehouseSendDonationOperationsTable(props) {
    var _this = this;
    var _a = (0, reduxHooks_1.useAppSelector)(function (state) { return state.warehouseSendDonationOperations; }), data = _a.data, status = _a.status;
    var currentUser = (0, reduxHooks_1.useAppSelector)(function (state) { return state.auth; }).currentUser;
    var dispatch = (0, reduxHooks_1.useAppDispatch)();
    var startOfToday = (0, moment_1.default)();
    var endOfToday = (0, moment_1.default)();
    var _b = (0, react_1.useState)(startOfToday.startOf("day")), startDate = _b[0], setStartDate = _b[1];
    var _c = (0, react_1.useState)(endOfToday.endOf("day")), endDate = _c[0], setEndDate = _c[1];
    var t = (0, react_i18next_1.useTranslation)().t;
    var warehouseId = props.warehouseId, warehouseItems = props.warehouseItems;
    var userId = currentUser === null || currentUser === void 0 ? void 0 : currentUser.id;
    var _d = (0, react_1.useState)(false), confirmingAll = _d[0], setConfirmingAll = _d[1];
    var _e = (0, react_1.useState)(false), confirming = _e[0], setConfirming = _e[1];
    var _f = (0, react_1.useState)(false), approvingAll = _f[0], setApprovingAll = _f[1];
    var _g = (0, react_1.useState)(false), approving = _g[0], setApproving = _g[1];
    var _h = (0, react_1.useState)(false), canceling = _h[0], setCanceling = _h[1];
    var _j = (0, react_1.useState)(""), SRNumber = _j[0], setSRNumber = _j[1];
    var _k = (0, react_1.useState)(false), disabledButtonConfirm = _k[0], setDisabledButtonConfirm = _k[1];
    var projects = (0, projectsForWarehouseRole_1.projectsForWarehouseRole)(warehouseId, "viewDonateWarehouseItems");
    (0, react_1.useEffect)(function () {
        dispatch((0, warehouseSendDonationOperationsSlice_1.fetchSenDonationOperationsByDate)({
            warehouseId: warehouseId,
            gt: startDate.toISOString(),
            ls: endDate.toISOString(),
            byField: "createdAt",
        }));
        var unsubscribe = (0, warehouseSendDonationOperationsSlice_1.subscribeToSendDonationOperations)(dispatch, warehouseId);
        return function () {
            unsubscribe();
        };
    }, [dispatch, startDate, endDate]);
    var confirmSendDonationItemPermission = (0, hasProjectAndWarehousePermission_1.hasProjectAndWarehousePermission)(warehouseId, ["confirmSendDonationItem"]);
    var approveSendDonationItemPermission = (0, hasProjectAndWarehousePermission_1.hasProjectAndWarehousePermission)(warehouseId, ["approveSendDonationItem"]);
    var warehouseSendDonationOperations = (0, react_1.useMemo)(function () {
        return (data !== null && data !== void 0 ? data : []).map(function (x) {
            var data = x;
            return __assign(__assign({}, data), { id: x.id });
        });
    }, [data]);
    var items = warehouseSendDonationOperations
        // .filter((e) => projects.includes(e.projectId))
        .filter(function (e) {
        if (SRNumber == "") {
            return true;
        }
        else {
            return e.SRNumber == SRNumber;
        }
    });
    var approveItems = items.filter(function (e) { return e.status == "donated"; });
    var confirmItems = items.filter(function (e) { return e.status == "pending donating confirmation"; });
    (0, react_1.useEffect)(function () {
        if (approveItems.length == 0) {
            setApprovingAll(false);
            setDisabledButtonConfirm(false);
        }
        if (confirmItems.length == 0) {
            setConfirmingAll(false);
            setDisabledButtonConfirm(false);
        }
    }, [warehouseSendDonationOperations, approvingAll, confirmingAll]);
    if (status == "loading") {
        return (0, jsx_runtime_1.jsx)(antd_1.Spin, {});
    }
    var columnsOfReceiveItems = [
        {
            name: "from",
            title: "From",
        },
        {
            name: "dnNumber",
            title: "From DN",
        },
        {
            name: "SRNumber",
            title: t("projects.SRNumber"),
        },
        {
            name: "projectId",
            title: t("projects.projectCode"),
            getCellValue: function (r) { var _a; return (_a = projectsList_1.globalProjectsData[r.projectId]) === null || _a === void 0 ? void 0 : _a.code; },
        },
        {
            name: "to",
            title: t("warehouse.to"),
        },
        {
            name: "cachedProductName",
            title: t("products.productName"),
        },
        {
            name: "cachedProductUnit",
            title: t("common.unit"),
            getCellValue: function (r) { var _a; return (_a = unitsList_1.globalUnitsData[r.cachedProductUnit]) === null || _a === void 0 ? void 0 : _a.name; },
        },
        {
            name: "cachedProductDescription",
            title: t("products.description"),
        },
        {
            name: "cachedProductCategory",
            title: t("products.productCategory"),
            getCellValue: function (r) { var _a; return (_a = categoriesList_1.globalCategoriesData[r.cachedProductCategory]) === null || _a === void 0 ? void 0 : _a.name; },
        },
        {
            name: "quantity",
            title: t("common.quantity"),
        },
        {
            name: "before",
            title: "Before",
        },
        {
            name: "after",
            title: "After",
        },
        {
            name: "stockNumber",
            title: t("warehouse.stockNumber"),
        },
        {
            name: "notes",
            title: t("common.notes"),
        },
        {
            name: "sentBy",
            title: t("warehouse.sentBy"),
            getCellValue: function (r) { var _a; return (_a = usersList_1.globalUsersData[r.sentBy]) === null || _a === void 0 ? void 0 : _a.name; },
        },
        {
            name: "serialNumbers",
            title: t("warehouse.serialNumbers"),
            getCellValue: function (r) {
                var _a;
                return typeof r.serialNumbers == "string"
                    ? r.serialNumbers
                    : (_a = r.serialNumbers) === null || _a === void 0 ? void 0 : _a.join(", ");
            },
        },
        {
            name: "assetsNumbers",
            title: t("warehouse.assetsNumbers"),
            getCellValue: function (r) {
                var _a;
                return typeof r.assetsNumbers == "string"
                    ? r.assetsNumbers
                    : (_a = r.assetsNumbers) === null || _a === void 0 ? void 0 : _a.join(", ");
            },
        },
        {
            name: "status",
            title: t("warehouse.status"),
        },
        {
            name: "createdAt",
            title: t("warehouse.createdAt"),
            getCellValue: function (r) {
                return t("common.date", { date: (0, moment_1.default)(r.createdAt).format("DD/MM/YYYY") });
            },
        },
        {
            name: "fileAttached",
            title: t("warehouse.fileAttatched"),
            getCellValue: function (r) {
                var url = r.SRAttachment;
                return ((0, jsx_runtime_1.jsx)("div", { children: r.SRAttachment ? ((0, jsx_runtime_1.jsx)("label", __assign({ className: "ant-btn ant-btn-link" }, { children: (0, jsx_runtime_1.jsxs)("a", __assign({ href: url, target: "_blank", rel: "noopener noreferrer" }, { children: [(0, jsx_runtime_1.jsx)(icons_1.PaperClipOutlined, {}), t("warehouse.downloadSRAttachment")] })) }))) : ("No attatchement") }));
            },
        },
        {
            name: "confirmation",
            title: t("warehouse.confirmation"),
            getCellValue: function (r) {
                return ((0, jsx_runtime_1.jsxs)("div", { children: [r.status === "pending donating confirmation" &&
                            confirmSendDonationItemPermission ? ((0, jsx_runtime_1.jsx)(antd_1.Button, __assign({ disabled: confirming, style: { color: "green" }, onClick: function () {
                                setConfirming(true);
                                dispatch((0, warehouseSendDonationOperationsSlice_1.editSendDonationOperation)({
                                    id: r.id,
                                    status: "donated",
                                    sentAt: (0, moment_1.default)(),
                                    confirmedBy: userId,
                                }))
                                    .then(function () { return __awaiter(_this, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        antd_1.message.success(t("alerts.success"));
                                        setConfirming(false);
                                        return [2 /*return*/];
                                    });
                                }); })
                                    .catch(function (e) {
                                    console.log(e);
                                    antd_1.message.error(t("alerts.error"));
                                });
                            } }, { children: t("warehouse.confirm") }))) : null, r.status === "pending donating confirmation" &&
                            confirmSendDonationItemPermission ? ((0, jsx_runtime_1.jsx)(antd_1.Button, __assign({ disabled: canceling, style: { margin: "5px", color: "red" }, onClick: function () { return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    setCanceling(true);
                                    dispatch((0, warehouseSendDonationOperationsSlice_1.editSendDonationOperation)({
                                        id: r.id,
                                        status: "cancelled",
                                    })).then(function () { return setCanceling(false); });
                                    return [2 /*return*/];
                                });
                            }); } }, { children: t("warehouse.cancel") }))) : null, r.status === "donated" && approveSendDonationItemPermission ? ((0, jsx_runtime_1.jsx)(antd_1.Button, __assign({ disabled: approving, style: { margin: "5px", color: "blue" }, onClick: function () { return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            setApproving(true);
                                            return [4 /*yield*/, (0, approveSendDonationItem_1.default)({
                                                    userId: currentUser === null || currentUser === void 0 ? void 0 : currentUser.id,
                                                    dispatch: dispatch,
                                                    warehouseId: warehouseId,
                                                    warehouseItems: warehouseItems,
                                                    warehouseTransferOperation: r,
                                                    warehouseTransferOperationId: r.id,
                                                }).then(function (e) {
                                                    console.log({ e: e });
                                                    setApproving(false);
                                                })];
                                        case 1:
                                            _a.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            }); } }, { children: t("warehouse.approve") }))) : null, r.status === "donated" && approveSendDonationItemPermission ? ((0, jsx_runtime_1.jsx)(antd_1.Button, __assign({ disabled: canceling, style: { margin: "5px", color: "red" }, onClick: function () { return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    setCanceling(true);
                                    dispatch((0, warehouseSendDonationOperationsSlice_1.editSendDonationOperation)({
                                        id: r.id,
                                        status: "cancelled",
                                    })).then(function () { return setCanceling(false); });
                                    return [2 /*return*/];
                                });
                            }); } }, { children: t("warehouse.cancel") }))) : null] }));
            },
        },
    ];
    var approveMany = function () {
        setApprovingAll(true);
        approveItems.map(function (item, index) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, (0, approveSendDonationItem_1.default)({
                            userId: currentUser === null || currentUser === void 0 ? void 0 : currentUser.id,
                            dispatch: dispatch,
                            warehouseId: warehouseId,
                            warehouseItems: warehouseItems,
                            warehouseTransferOperation: item,
                            warehouseTransferOperationId: item.id,
                        })
                            .then(function () { })
                            .catch(function (e) {
                            console.log(e);
                            antd_1.message.error("Error in item ".concat(item.stockNumber));
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); });
    };
    var confirmMany = function () {
        setConfirmingAll(true);
        confirmItems.map(function (item, index) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, dispatch((0, warehouseSendDonationOperationsSlice_1.editSendDonationOperation)({
                            id: item.id,
                            status: "donated",
                            sentAt: (0, moment_1.default)(),
                            confirmedBy: userId,
                        }))
                            .then(function () { return antd_1.message.success("Done!"); })
                            .catch(function (e) {
                            console.log(e);
                            antd_1.message.error(e);
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); });
    };
    return ((0, jsx_runtime_1.jsx)(antd_1.Spin, __assign({ spinning: confirmingAll || approvingAll || approving || confirming || canceling, size: "large" }, { children: (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsxs)("span", { children: [t("warehouse.filterStartDate"), (0, jsx_runtime_1.jsx)(antd_1.DatePicker, { onChange: function (e) { return setStartDate(e.startOf("day")); }, value: startDate })] }), (0, jsx_runtime_1.jsxs)("span", { children: [" ", t("warehouse.filterEndDate")] }), (0, jsx_runtime_1.jsx)(antd_1.DatePicker, { onChange: function (e) { return setEndDate(e.endOf("day")); }, value: endDate }), (0, jsx_runtime_1.jsx)(antd_1.Input, { value: SRNumber, onChange: function (e) { return setSRNumber(e.target.value); }, allowClear: true, placeholder: "SR Number", style: { width: "20%", paddingLeft: "1%", paddingRight: "1%" } }), approveSendDonationItemPermission && approveItems.length > 0 ? ((0, jsx_runtime_1.jsx)(antd_1.Popconfirm, __assign({ title: "Are you sure?", okText: "Yes", cancelText: "No", onConfirm: function () { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            setDisabledButtonConfirm(true);
                            approveMany();
                            return [2 /*return*/];
                        });
                    }); } }, { children: (0, jsx_runtime_1.jsxs)(antd_1.Button, __assign({ disabled: disabledButtonConfirm, style: { marginLeft: "1%" } }, { children: ["Approve All ", approveItems.length] })) }))) : null, confirmSendDonationItemPermission && confirmItems.length > 0 ? ((0, jsx_runtime_1.jsx)(antd_1.Popconfirm, __assign({ title: "Are you sure?", okText: "Yes", cancelText: "No", onConfirm: function () { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            setDisabledButtonConfirm(true);
                            confirmMany();
                            return [2 /*return*/];
                        });
                    }); } }, { children: (0, jsx_runtime_1.jsxs)(antd_1.Button, __assign({ disabled: disabledButtonConfirm, style: { marginLeft: "1%" } }, { children: ["Confirm All ", confirmItems.length] })) }))) : null, (0, jsx_runtime_1.jsx)(antd_1.Button, __assign({ style: {
                        margin: "1%",
                    }, onClick: function () { return __awaiter(_this, void 0, void 0, function () {
                        var fileName, fields, titles;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    fileName = "Warehouse Send Donation Table";
                                    fields = [
                                        "warehouseId",
                                        "projectId",
                                        "cachedProductName",
                                        "cachedProductDescription",
                                        "cachedProductUnit",
                                        "cachedProductCategory",
                                        "quantity",
                                        "serialNumbers",
                                        "assetsNumbers",
                                        "stockNumber",
                                        "batchNumber",
                                        "SRNumber",
                                        "createdAt",
                                        "to",
                                        "receivedBy",
                                        "notes",
                                    ];
                                    titles = [
                                        "Warehouse",
                                        "Project",
                                        "Product Name",
                                        "Product Description",
                                        "Product Unit",
                                        "Cached product category",
                                        "Product Quantity",
                                        "Serial Numbers",
                                        "Assets Numbers",
                                        "Stock Number",
                                        "Batch Number",
                                        "SRNumber",
                                        "Created At",
                                        "to",
                                        "Received by",
                                        "Notes",
                                    ];
                                    return [4 /*yield*/, (0, exportWarehouseItemsTableToExcel_1.exportWarehouseItemsTableToExcel)(data, fields, titles, fileName)];
                                case 1:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); } }, { children: t("common.exportToExcel") })), (0, jsx_runtime_1.jsxs)(dx_react_grid_material_ui_1.Grid, __assign({ rows: items, columns: columnsOfReceiveItems, getRowId: function (r) { return r.id; } }, { children: __spreadArray([], (0, defaultDevExtremeGridComponents_1.default)({
                        pagination: true,
                        pageSize: 50,
                    }), true) }))] }) })));
}
exports.default = WarehouseSendDonationOperationsTable;
